const STR = {
  en: {
    app: "TabletsTalk",
    tagline: "The tablet talks from the label. You talk only to your doctor.",
    familyLogin: "Patient / family",
    staffLogin: "Doctor / clinic",
    phone: "Mobile number",
    sendOtp: "Send code",
    otpHint: "A 6-digit code. In this pilot it appears on the next screen.",
    enterOtp: "Enter 6-digit code",
    verify: "Open my medicines",
    password: "Password",
    continueOtp: "Continue → code",
    staffVerify: "Open my board",
    change: "Change",
    back: "Back",
    loading: "Opening TabletsTalk…",
    myMedicines: "My medicines",
    board: "Board",
    writeRx: "Write prescription",
    me: "Me",
    logout: "Logout",
    neverStop: "This app does not tell you to stop a medicine, and does not say a drug is wrong.",
    labelList: "On the label",
    livedList: "What you felt",
    seeFull: "See full list",
    hideFull: "Hide the long list",
    tickThis: "I felt this",
    thisIsBad: "This is bad — tell my doctor",
    somethingElse: "Something not on the label",
    writeWhat: "Write what you felt",
    howBad: "How bad?",
    mild: "Mild",
    callDoctor: "Needs a call",
    emergency: "Emergency",
    when: "When it started",
    still: "Still happening",
    stopped: "It stopped",
    saveTick: "Save for my doctor",
    photoPack: "Photo of the strip",
    takePhoto: "Photograph the pack",
    confirmSalt: "This is the salt on your strip",
    brand: "Brand",
    salt: "Salt",
    strength: "Strength",
    dose: "Dose",
    days: "Days",
    why: "Why the doctor wrote it",
    expected: "On the label",
    unexpected: "Not on the label",
    notified: "Your doctor has been notified.",
    noRx: "No clinic slip yet. You can still pick the pack at home and tick what you felt.",
    common: "Common",
    veryCommon: "Very common",
    uncommon: "Uncommon",
    rare: "Rare",
    firstDays: "Often in the first days",
    weeksLater: "Often after weeks",
    anytime: "Can happen any time",
    stomach: "Stomach",
    skin: "Skin",
    sleep: "Sleep / mood",
    heart: "Heart",
    sugar: "Sugar",
    kidneys: "Kidneys",
    other: "Other",
    whoReported: "Who reported",
    howSevere: "How severe",
    whetherExpected: "Expected?",
    patientPhone: "Patient mobile",
    patientName: "Patient name",
    pickMedicine: "Pack",
    findPack: "Type brand or salt",
    write: "Give this prescription",
    writeFastHint:
      "Phone. Tap the pack. Give. Add the next tablet for the same person. The label list is already on the pack — do not type side effects here.",
    givenRx: "Given",
    addAnother: "Give another for this patient",
    whyBp: "Blood pressure",
    whySugar: "Sugar",
    whyInfection: "Infection",
    whyPain: "Pain",
    yourPanel: "Your patients only. Other clinics are not shown.",
    name: "Your name",
    language: "Language",
    save: "Save",
    hindi: "हिन्दी",
    telugu: "తెలుగు",
    english: "English",
    doctorName: "Doctor",
    emptyBoard: "No ticks yet. When a family reports, it lands here — not on the internet.",
    listedCommon: "This is listed as common.",
    listedSerious: "This is listed as serious — contact your doctor.",
    clinicDoctors: "Clinic doctors",
    doctorsNav: "Doctors",
    addDoctor: "Add a doctor",
    doctorPhone: "Doctor mobile",
    doctorPassword: "Login password",
    confirmPassword: "Confirm password",
    doctorAdded: "They can log in on Doctor / clinic with this mobile and password.",
    clinicDoctorsHint:
      "Clinic desk adds doctors here. They use Staff login — password, then the code on screen. Then they write prescriptions for families.",
    noDoctorsYet: "No doctors on this clinic yet.",
    passwordsMismatch: "The two passwords do not match.",
    passwordHint: "At least 6 characters.",
    addHomePack: "A pack we have at home",
    homePackHint:
      "Pick the strip. Tick what you felt. Names stay off the wall. If you have a doctor on TabletsTalk, they still see your ticks on their board.",
    familyLogged: "Logged at home",
    wall: "Wall",
    seeWall: "See the salt wall",
    wallHint:
      "Each salt on the clinic list. How many families ticked each labelled effect. No names, no villages, no free-text stories. Not a reason to stop a medicine.",
    wallFamilies: "families",
    notOnLabel: "Not on the label",
    wallEmpty: "No packs on the wall yet.",
    confirmPack: "Yes, this is our strip",
    inMemory: "In loving memory",
    dedicationName: "Balamani Konatham",
    dedicationDates: "8 January 1946 — 17 June 2026",
    dedicationBody:
      "The insert is one paper. What she felt was the other. A wound the label did not speak of in time. TabletsTalk exists so a family can tell their own doctor — how it started, how bad — without the app ever saying stop this medicine.",
    sceneFamily: "Family felt it",
    sceneDoctor: "Doctor hears it",
    sceneMedicine: "The strip talks",
  },
  hi: {
    app: "TabletsTalk",
    tagline: "गोली लेबल से बोलती है। आप सिर्फ अपने डॉक्टर से बात करते हैं।",
    familyLogin: "मरीज़ / परिवार",
    staffLogin: "डॉक्टर / क्लिनिक",
    phone: "मोबाइल नंबर",
    sendOtp: "कोड भेजें",
    otpHint: "6 अंकों का कोड। इस पायलट में अगली स्क्रीन पर दिखेगा।",
    enterOtp: "6 अंकों का कोड लिखें",
    verify: "मेरी दवाएँ खोलें",
    password: "पासवर्ड",
    continueOtp: "आगे → कोड",
    staffVerify: "मेरा बोर्ड खोलें",
    change: "बदलें",
    back: "वापस",
    loading: "TabletsTalk खुल रहा है…",
    myMedicines: "मेरी दवाएँ",
    board: "बोर्ड",
    writeRx: "पर्ची लिखें",
    me: "मैं",
    logout: "बाहर जाएँ",
    neverStop: "यह ऐप दवा बंद करने को नहीं कहता, और यह नहीं कहता कि दवा गलत है।",
    labelList: "लेबल पर लिखा है",
    livedList: "आपने क्या महसूस किया",
    seeFull: "पूरी सूची देखें",
    hideFull: "लंबी सूची छुपाएँ",
    tickThis: "यह महसूस हुआ",
    thisIsBad: "यह बुरा है — डॉक्टर को बताओ",
    somethingElse: "लेबल पर नहीं है",
    writeWhat: "जो महसूस हुआ वह लिखें",
    howBad: "कितना तेज़?",
    mild: "हल्का",
    callDoctor: "फोन करना चाहिए",
    emergency: "आपातकाल",
    when: "कब शुरू हुआ",
    still: "अभी भी हो रहा है",
    stopped: "रुक गया",
    saveTick: "डॉक्टर के लिए सहेजें",
    photoPack: "पट्टी की फोटो",
    takePhoto: "पैक की तस्वीर लें",
    confirmSalt: "आपकी पट्टी पर यह नमक है",
    brand: "ब्रांड",
    salt: "नमक (सॉल्ट)",
    strength: "ताकत",
    dose: "खुराक",
    days: "दिन",
    why: "डॉक्टर ने क्यों लिखी",
    expected: "लेबल पर है",
    unexpected: "लेबल पर नहीं",
    notified: "आपके डॉक्टर को सूचना दे दी गई है।",
    noRx: "अभी क्लिनिक की पर्ची नहीं। घर की पट्टी चुनकर जो महसूस हुआ वह टिक कर सकते हैं।",
    common: "आम",
    veryCommon: "बहुत आम",
    uncommon: "कम",
    rare: "दुर्लभ",
    firstDays: "अक्सर पहले दिनों में",
    weeksLater: "अक्सर हफ्तों बाद",
    anytime: "कभी भी हो सकता है",
    stomach: "पेट",
    skin: "त्वचा",
    sleep: "नींद / मूड",
    heart: "दिल",
    sugar: "शुगर",
    kidneys: "गुर्दे",
    other: "और",
    whoReported: "किसने बताया",
    howSevere: "कितना गंभीर",
    whetherExpected: "लेबल पर था?",
    patientPhone: "मरीज़ का मोबाइल",
    patientName: "मरीज़ का नाम",
    pickMedicine: "पट्टी",
    findPack: "ब्रांड या नमक लिखें",
    write: "यह पर्ची दें",
    writeFastHint:
      "फ़ोन। पट्टी चुनें। दें। उसी मरीज़ के लिए अगली गोली जोड़ें। लेबल पहले से पट्टी पर है — यहाँ साइड इफेक्ट न लिखें।",
    givenRx: "दे दी",
    addAnother: "इसी मरीज़ को और दें",
    whyBp: "ब्लड प्रेशर",
    whySugar: "शुगर",
    whyInfection: "इन्फेक्शन",
    whyPain: "दर्द",
    yourPanel: "सिर्फ आपके मरीज़। दूसरे क्लिनिक नहीं दिखते।",
    name: "आपका नाम",
    language: "भाषा",
    save: "सहेजें",
    hindi: "हिन्दी",
    telugu: "తెలుగు",
    english: "English",
    doctorName: "डॉक्टर",
    emptyBoard: "अभी कोई टिक नहीं। परिवार बताएगा तो यहीं आएगा — इंटरनेट पर नहीं।",
    listedCommon: "यह आम सूची में है।",
    listedSerious: "यह गंभीर सूची में है — डॉक्टर से संपर्क करें।",
    clinicDoctors: "क्लिनिक के डॉक्टर",
    doctorsNav: "डॉक्टर",
    addDoctor: "डॉक्टर जोड़ें",
    doctorPhone: "डॉक्टर का मोबाइल",
    doctorPassword: "लॉगिन पासवर्ड",
    confirmPassword: "पासवर्ड फिर लिखें",
    doctorAdded: "अब वे डॉक्टर / क्लिनिक पर इस मोबाइल और पासवर्ड से लॉगिन कर सकते हैं।",
    clinicDoctorsHint:
      "क्लिनिक डेस्क यहाँ डॉक्टर जोड़ता है। वे स्टाफ लॉगिन इस्तेमाल करें — पासवर्ड, फिर स्क्रीन पर कोड। उसके बाद वे परिवार के लिए पर्ची लिखते हैं।",
    noDoctorsYet: "इस क्लिनिक पर अभी कोई डॉक्टर नहीं।",
    passwordsMismatch: "दोनों पासवर्ड एक जैसे नहीं हैं।",
    passwordHint: "कम से कम 6 अक्षर।",
    addHomePack: "घर की पट्टी",
    homePackHint:
      "पट्टी चुनें। जो महसूस हुआ टिक करें। नाम दीवार पर नहीं आते। डॉक्टर TabletsTalk पर हों तो टिक उनके बोर्ड पर भी जाते हैं।",
    familyLogged: "घर से जोड़ी",
    wall: "दीवार",
    seeWall: "नमक की दीवार देखें",
    wallHint:
      "क्लिनिक सूची का हर नमक। कितने परिवारों ने लेबल वाली बात टिक की। नाम, गाँव, लिखी कहानी नहीं। दवा बंद करने की वजह नहीं।",
    wallFamilies: "परिवार",
    notOnLabel: "लेबल पर नहीं",
    wallEmpty: "दीवार पर अभी कोई पट्टी नहीं।",
    confirmPack: "हाँ, यही हमारी पट्टी है",
    inMemory: "स्मृति में",
    dedicationName: "बालामणि कोनथम",
    dedicationDates: "8 जनवरी 1946 — 17 जून 2026",
    dedicationBody:
      "लेबल एक कागज़ है। जो उन्होंने महसूस किया, वह दूसरा है। एक घाव जिसके बारे में लेबल ने समय पर नहीं कहा। TabletsTalk इसलिए है कि परिवार अपने डॉक्टर को बता सके — कब शुरू हुआ, कितना बुरा — बिना ऐप के दवा बंद कहे।",
    sceneFamily: "परिवार ने महसूस किया",
    sceneDoctor: "डॉक्टर सुनता है",
    sceneMedicine: "पट्टी बोलती है",
  },
  te: {
    app: "TabletsTalk",
    tagline: "మాత్ర లేబుల్ నుంచి మాట్లాడుతుంది. మీరు మీ డాక్టర్‌తో మాత్రమే మాట్లాడతారు.",
    familyLogin: "రోగి / కుటుంబం",
    staffLogin: "డాక్టర్ / క్లినిక్",
    phone: "మొబైల్ నంబర్",
    sendOtp: "కోడ్ పంపండి",
    otpHint: "6 అంకెల కోడ్. ఈ పైలట్‌లో తర్వాతి స్క్రీన్‌లో కనిపిస్తుంది.",
    enterOtp: "6 అంకెల కోడ్ రాయండి",
    verify: "నా మందులు తెరవండి",
    password: "పాస్‌వర్డ్",
    continueOtp: "ముందుకు → కోడ్",
    staffVerify: "నా బోర్డ్ తెరవండి",
    change: "మార్చండి",
    back: "వెనక్కి",
    loading: "TabletsTalk తెరుస్తోంది…",
    myMedicines: "నా మందులు",
    board: "బోర్డ్",
    writeRx: "ప్రిస్క్రిప్షన్ రాయండి",
    me: "నేను",
    logout: "నిష్క్రమించు",
    neverStop: "ఈ యాప్ మందు ఆపమని చెప్పదు, మందు తప్పు అని చెప్పదు.",
    labelList: "లేబుల్‌పై ఉన్నది",
    livedList: "మీరు ఏమి అనుభవించారు",
    seeFull: "పూర్తి జాబితా",
    hideFull: "పొడవైన జాబితా దాచు",
    tickThis: "ఇది అనిపించింది",
    thisIsBad: "ఇది చెడు — డాక్టర్‌కు చెప్పండి",
    somethingElse: "లేబుల్‌పై లేదు",
    writeWhat: "ఏమి అనిపించిందో రాయండి",
    howBad: "ఎంత తీవ్రం?",
    mild: "తేలిక",
    callDoctor: "ఫోన్ చేయాలి",
    emergency: "అత్యవసరం",
    when: "ఎప్పుడు మొదలైంది",
    still: "ఇంకా ఉంది",
    stopped: "ఆగింది",
    saveTick: "డాక్టర్ కోసం సేవ్",
    photoPack: "స్ట్రిప్ ఫోటో",
    takePhoto: "ప్యాక్ ఫోటో తీయండి",
    confirmSalt: "మీ స్ట్రిప్‌పై ఈ ఉప్పు ఉంది",
    brand: "బ్రాండ్",
    salt: "ఉప్పు (సాల్ట్)",
    strength: "స్ట్రెంత్",
    dose: "మోతాదు",
    days: "రోజులు",
    why: "డాక్టర్ ఎందుకు రాశారు",
    expected: "లేబుల్‌పై ఉంది",
    unexpected: "లేబుల్‌పై లేదు",
    notified: "మీ డాక్టర్‌కు తెలియజేయబడింది.",
    noRx: "ఇంకా క్లినిక్ స్లిప్ లేదు. ఇంట్లో ఉన్న స్ట్రిప్ ఎంచుకుని అనిపించింది టిక్ చేయవచ్చు.",
    common: "సాధారణం",
    veryCommon: "చాలా సాధారణం",
    uncommon: "అరుదు",
    rare: "చాలా అరుదు",
    firstDays: "తరచు మొదటి రోజుల్లో",
    weeksLater: "తరచు వారాల తర్వాత",
    anytime: "ఎప్పుడైనా కావచ్చు",
    stomach: "కడుపు",
    skin: "చర్మం",
    sleep: "నిద్ర / మూడ్",
    heart: "గుండె",
    sugar: "షుగర్",
    kidneys: "మూత్రపిండాలు",
    other: "ఇతర",
    whoReported: "ఎవరు చెప్పారు",
    howSevere: "ఎంత తీవ్రం",
    whetherExpected: "లేబుల్‌పై ఉందా?",
    patientPhone: "రోగి మొబైల్",
    patientName: "రోగి పేరు",
    pickMedicine: "స్ట్రిప్",
    findPack: "బ్రాండ్ లేదా ఉప్పు రాయండి",
    write: "ఈ ప్రిస్క్రిప్షన్ ఇవ్వండి",
    writeFastHint:
      "ఫోన్. స్ట్రిప్ నొక్కండి. ఇవ్వండి. అదే రోగికి తర్వాతి మాత్ర. లేబుల్ ఇప్పటికే స్ట్రిప్‌పై ఉంది — ఇక్కడ సైడ్ ఎఫెక్ట్ రాయవద్దు.",
    givenRx: "ఇచ్చారు",
    addAnother: "ఇదే రోగికి మరొకటి ఇవ్వండి",
    whyBp: "బిపి",
    whySugar: "షుగర్",
    whyInfection: "ఇన్‌ఫెక్షన్",
    whyPain: "నొప్పి",
    yourPanel: "మీ రోగులు మాత్రమే. ఇతర క్లినిక్‌లు కనిపించవు.",
    name: "మీ పేరు",
    language: "భాష",
    save: "సేవ్",
    hindi: "हिन्दी",
    telugu: "తెలుగు",
    english: "English",
    doctorName: "డాక్టర్",
    emptyBoard: "ఇంకా టిక్ లేవు. కుటుంబం చెబితే ఇక్కడికి వస్తుంది — ఇంటర్నెట్‌కు కాదు.",
    listedCommon: "ఇది సాధారణ జాబితాలో ఉంది.",
    listedSerious: "ఇది తీవ్రమైన జాబితాలో ఉంది — డాక్టర్‌ను సంప్రదించండి.",
    clinicDoctors: "క్లినిక్ డాక్టర్లు",
    doctorsNav: "డాక్టర్లు",
    addDoctor: "డాక్టర్ జోడించండి",
    doctorPhone: "డాక్టర్ మొబైల్",
    doctorPassword: "లాగిన్ పాస్‌వర్డ్",
    confirmPassword: "పాస్‌వర్డ్ మళ్లీ రాయండి",
    doctorAdded: "ఇప్పుడు వారు డాక్టర్ / క్లినిక్‌లో ఈ మొబైల్ మరియు పాస్‌వర్డ్‌తో లాగిన్ అవ్వవచ్చు.",
    clinicDoctorsHint:
      "క్లినిక్ డెస్క్ ఇక్కడ డాక్టర్లను జోడిస్తుంది. వారు స్టాఫ్ లాగిన్ — పాస్‌వర్డ్, తర్వాత స్క్రీన్‌పై కోడ్. తర్వాత కుటుంబాలకు ప్రిస్క్రిప్షన్ రాస్తారు.",
    noDoctorsYet: "ఈ క్లినిక్‌లో ఇంకా డాక్టర్లు లేరు.",
    passwordsMismatch: "రెండు పాస్‌వర్డ్‌లు సరిపోలడం లేదు.",
    passwordHint: "కనీసం 6 అక్షరాలు.",
    addHomePack: "ఇంట్లో ఉన్న స్ట్రిప్",
    homePackHint:
      "స్ట్రిప్ ఎంచుకోండి. అనిపించింది టిక్ చేయండి. పేర్లు గోడపై ఉండవు. డాక్టర్ TabletsTalkలో ఉంటే టిక్‌లు వారి బోర్డ్‌కు కూడా వెళ్తాయి.",
    familyLogged: "ఇంటి నుంచి",
    wall: "గోడ",
    seeWall: "ఉప్పు గోడ చూడండి",
    wallHint:
      "క్లినిక్ జాబితాలోని ప్రతి ఉప్పు. ఎన్ని కుటుంబాలు లేబుల్ విషయం టిక్ చేశాయి. పేర్లు, ఊరు, రాసిన కథ లేవు. మందు ఆపే కారణం కాదు.",
    wallFamilies: "కుటుంబాలు",
    notOnLabel: "లేబుల్‌పై లేదు",
    wallEmpty: "గోడపై ఇంకా స్ట్రిప్‌లు లేవు.",
    confirmPack: "అవును, ఇదే మా స్ట్రిప్",
    inMemory: "స్మృతిలో",
    dedicationName: "బాలామణి కొణతం",
    dedicationDates: "8 జనవరి 1946 — 17 జూన్ 2026",
    dedicationBody:
      "లేబుల్ ఒక కాగితం. ఆమె అనుభవించింది మరొకటి. లేబుల్ సమయానికి చెప్పని గాయం. TabletsTalk ఉన్నది కుటుంబం తమ డాక్టర్‌కు చెప్పడానికి — ఎప్పుడు మొదలైంది, ఎంత తీవ్రం — యాప్ మందు ఆపమని చెప్పకుండా.",
    sceneFamily: "కుటుంబం అనుభవించింది",
    sceneDoctor: "డాక్టర్ వింటారు",
    sceneMedicine: "స్ట్రిప్ మాట్లాడుతుంది",
  },
};

export function t(lang, key) {
  const code = STR[lang] ? lang : "hi";
  return STR[code][key] || STR.en[key] || key;
}

export const LANGS = [
  { id: "hi", label: "हिन्दी" },
  { id: "te", label: "తెలుగు" },
  { id: "en", label: "English" },
];
